import * as API from './../../base/api_service';
import * as serviceCallConfig from './../../config/api_urls';

export var ADMIN_DASHBOARD = 'ADMIN_DASHBOARD';
export var ADMIN_DASHBOARD_DATA = 'ADMIN_DASHBOARD_DATA';
export var ADMIN_DASHBOARD_DETAILS_FAIL = 'ADMIN_DASHBOARD_DETAILS_FAIL';


export var dashboardData = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ADMIN_DASHBOARD),//endPoint
            '',//payLoad
            serviceCallConfig.ADMIN_DASHBOARD,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



export var adminDashboard_data = (data) => ({
    type: ADMIN_DASHBOARD_DATA,
    data: data
});

export var adminDashboard_data_failed = (data) => {
    return ({
        type: ADMIN_DASHBOARD_DETAILS_FAIL,
        data: data
    });
};



/** WEBPACK FOOTER **
 ** ./src/actions/admin/dashboard_actions.js
 **/